import FileInputUploadFieldNew from 'components/styledFormElements/FineInputUploadNew'
import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useObjectUrl } from 'hooks/useObjectUrl'
import { getImageSrc } from 'services/util'

type Props = {
    onValueChange: (hasValue: boolean) => void
}

const DefaultAvatarSettings = ({ onValueChange }: Props) => {
    const {
        control,
        formState: { errors },
    } = useFormContext<any>();
    const watchedAvatar = useWatch({ control, name: 'default_avatar_image' })
    const thumbPreview = useObjectUrl(watchedAvatar)

    useEffect(() => {
        onValueChange?.(Boolean(watchedAvatar))
    }, [watchedAvatar, onValueChange])

    return (
        <FileInputUploadFieldNew
            label="avatar"
            name="default_avatar_image"
            control={control}
            errors={errors}
            preview={getImageSrc(thumbPreview)}
            allowedTypes={[
                'image/jpeg',
                'image/png',
                'image/jpg',
            ]}
            tooltip={{
                title: 'Image requirements',
                items: [
                    '2:3 aspect ratio',
                    'JPG / PNG',
                    '≤ 1 MB',
                ],
                position: "right"
            }}
        />
    )
}

export default DefaultAvatarSettings
